"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var auth_1 = require("../features/apis/auth");
var customers_1 = require("../features/apis/customers");
var disbursements_1 = require("../features/apis/disbursements");
var orders_1 = require("../features/apis/orders");
var organizations_1 = require("../features/apis/organizations");
var products_1 = require("../features/apis/products");
var reports_1 = require("../features/apis/reports");
var roles_1 = require("../features/apis/roles");
var scheduler_1 = require("../features/apis/scheduler");
var stock_1 = require("../features/apis/stock");
var system_settings_1 = require("../features/apis/system-settings");
var users_1 = require("../features/apis/users");
var ussd_1 = require("../features/apis/ussd");
var auth_2 = require("../features/slices/auth");
var content_dialog_1 = require("../features/slices/content-dialog");
var message_dialog_1 = require("../features/slices/message-dialog");
exports.store = (0, toolkit_1.configureStore)({
    devTools: process.env.ENVIRONMENT !== "PROD",
    reducer: (_a = {
            auth: auth_2.authReducer,
            messageDialog: message_dialog_1.messageDialogReducer,
            contentDialog: content_dialog_1.contentDialogReducer
        },
        _a[auth_1.authApi.reducerPath] = auth_1.authApi.reducer,
        _a[customers_1.customersApi.reducerPath] = customers_1.customersApi.reducer,
        _a[organizations_1.organizationsApi.reducerPath] = organizations_1.organizationsApi.reducer,
        _a[roles_1.rolesApi.reducerPath] = roles_1.rolesApi.reducer,
        _a[users_1.usersApi.reducerPath] = users_1.usersApi.reducer,
        _a[products_1.productsApi.reducerPath] = products_1.productsApi.reducer,
        _a[stock_1.stockApi.reducerPath] = stock_1.stockApi.reducer,
        _a[orders_1.ordersApi.reducerPath] = orders_1.ordersApi.reducer,
        _a[disbursements_1.disbursementsApi.reducerPath] = disbursements_1.disbursementsApi.reducer,
        _a[reports_1.reportsApi.reducerPath] = reports_1.reportsApi.reducer,
        _a[ussd_1.ussdApi.reducerPath] = ussd_1.ussdApi.reducer,
        _a[system_settings_1.systemSettingsApi.reducerPath] = system_settings_1.systemSettingsApi.reducer,
        _a[scheduler_1.schedulerApi.reducerPath] = scheduler_1.schedulerApi.reducer,
        _a),
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware().concat([
            auth_1.authApi.middleware,
            customers_1.customersApi.middleware,
            organizations_1.organizationsApi.middleware,
            roles_1.rolesApi.middleware,
            users_1.usersApi.middleware,
            products_1.productsApi.middleware,
            stock_1.stockApi.middleware,
            orders_1.ordersApi.middleware,
            disbursements_1.disbursementsApi.middleware,
            reports_1.reportsApi.middleware,
            ussd_1.ussdApi.middleware,
            system_settings_1.systemSettingsApi.middleware,
            scheduler_1.schedulerApi.middleware,
        ]);
    },
});
